import Vue from 'vue'
import router from './router'
import store from './store'
import FastClick from 'fastclick'

// import 'babel-polyfill'
FastClick.attach(document.body)
Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	store,
	created () {
		// this.$store.dispatch('SetLoading',true)
	}
})



// WEBPACK FOOTER //
// ./src/main.js